import { render, staticRenderFns } from "./courseForm.vue?vue&type=template&id=f09585ec&"
import script from "./courseForm.vue?vue&type=script&lang=js&"
export * from "./courseForm.vue?vue&type=script&lang=js&"
import style0 from "./courseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports